import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { ColorPicker } from '../components/color-picker.js';
import { hexToHsva, hsvaToHex } from '../utils/convert.js';
import { equalHex } from '../utils/compare.js';
var colorModel = {
  defaultColor: '#000',
  toHsva: hexToHsva,
  fromHsva: function fromHsva(_ref) {
    var h = _ref.h,
      s = _ref.s,
      v = _ref.v;
    return hsvaToHex({
      h: h,
      s: s,
      v: v,
      a: 1
    });
  },
  equal: equalHex,
  fromAttr: function fromAttr(color) {
    return color;
  }
};
export var HexBase = /*#__PURE__*/function (_ColorPicker) {
  _inherits(HexBase, _ColorPicker);
  var _super = _createSuper(HexBase);
  function HexBase() {
    _classCallCheck(this, HexBase);
    return _super.apply(this, arguments);
  }
  _createClass(HexBase, [{
    key: "colorModel",
    get: function get() {
      return colorModel;
    }
  }]);
  return HexBase;
}(ColorPicker);